const membership = {
  // Hero Section
  heroTitle: 'Choose Your Membership Plan',
  premiumFeatures: 'Premium Features',
  prioritySupport: 'Priority Support',
  cancelAnytime: 'Cancel Anytime',

  // Tabs
  agentMemberships: 'Agent Memberships',
  premiumUserAccess: 'Premium User Access',

  // Badge
  mostPopular: 'Most Popular',
  perMonth: '/month',
  perYear: '/year',

  // Agent Plans
  basicAgent: 'Basic Agent',
  basicAgentDesc: 'Perfect for new agents getting started',
  basicFeature1: 'List up to 10 properties',
  basicFeature2: 'Basic analytics dashboard',
  basicFeature3: 'Email support',
  basicFeature4: 'Property management tools',
  basicFeature5: 'Standard listing visibility',

  premiumAgent: 'Premium Agent',
  premiumAgentDesc: 'Most popular choice for active agents',
  premiumFeature1: 'List up to 50 properties',
  premiumFeature2: 'Advanced analytics & insights',
  premiumFeature3: 'Priority email & phone support',
  premiumFeature4: 'Featured listings',
  premiumFeature5: 'Custom branding options',
  premiumFeature6: 'Lead generation tools',

  enterpriseAgent: 'Enterprise Agent',
  enterpriseAgentDesc: 'For established agencies and teams',
  enterpriseFeature1: 'Unlimited property listings',
  enterpriseFeature2: 'Full analytics suite',
  enterpriseFeature3: '24/7 dedicated support',
  enterpriseFeature4: 'Premium featured listings',
  enterpriseFeature5: 'Advanced custom branding',
  enterpriseFeature6: 'Team management tools',
  enterpriseFeature7: 'API access',
  enterpriseFeature8: 'White-label solutions',

  // User Plans
  premiumUser: 'Premium User',
  premiumUserDesc: 'Get exclusive access to premium properties and early notifications',
  userFeature1: 'Early access to new listings',
  userFeature2: 'Save unlimited favorites',
  userFeature3: 'Advanced search filters',
  userFeature4: 'Price drop notifications',
  userFeature5: 'Priority viewing appointments',
  userFeature6: 'Ad-free experience',

  // Buttons
  subscribe: 'Subscribe Now',
  contactSales: 'Contact Sales',

  // FAQ Section
  faqTitle: 'Frequently Asked Questions',
  faqQuestion1: 'Can I cancel my subscription anytime?',
  faqAnswer1: 'Yes, you can cancel your subscription at any time from your profile settings. Your access will continue until the end of your current billing period.',
  faqQuestion2: 'What payment methods do you accept?',
  faqAnswer2: 'We accept all major credit cards (Visa, MasterCard, American Express) and payments are processed securely through Stripe.',
  faqQuestion3: 'Can I upgrade or downgrade my plan?',
  faqAnswer3: 'Yes, you can change your plan anytime. When upgrading, you\'ll be charged a prorated amount. When downgrading, the new rate applies at the next billing cycle.',
  faqQuestion4: 'Is there a free trial available?',
  faqAnswer4: 'We offer a 14-day free trial for Premium Agent and Enterprise Agent plans. No credit card required to start your trial.',
  faqQuestion5: 'What happens to my listings if I cancel?',
  faqAnswer5: 'Your listings will remain active for 30 days after cancellation, giving you time to transition. After that, they will be archived but not deleted.',
  faqQuestion6: 'Do you offer discounts for annual billing?',
  faqAnswer6: 'Yes! Save 20% when you choose annual billing on any plan. The discount is automatically applied when you select yearly billing.',

  // Help Section
  needHelpChoosing: 'Need Help Choosing?',
  contactSalesTeam: 'Contact Sales Team',
  contactSalesDesc: 'Our sales team is here to help you find the perfect plan for your needs.',

  // Success Page
  successTitle: 'Subscription Confirmed',
  successMessage: 'Thank you for subscribing! Your membership has been activated.',
  successDetails: 'A confirmation email with billing details is on the way. You can now access your premium tools and manage your membership from your profile.',
  goToProfile: 'Go to Profile',
  returnToMemberships: 'Return to Memberships',
  checkoutCompleted: 'Your subscription checkout was completed.',
  sessionConfirmed: 'Stripe session {sessionId} confirmed.',

  // Alert Messages
  signInRequired: 'Please sign in to subscribe to a membership plan.',
  checkoutDisabled: 'Stripe checkout is disabled in this demo mode.',

  // The two-step subscribe indicator (pages/membership/page.tsx).
  steps: {
    label: 'Subscription steps',
    choosePlan: 'Choose a plan',
    details: 'Details & subscribe',
  },
};

export default membership;
